import React from "react";

import { StyledSVG } from "../StyledIcon";

export const SadIcon = props => {
  const { iconColor, iconWidth, iconHeight } = props;

  return (
    <StyledSVG
      xmlns="http://www.w3.org/2000/svg"
      width={iconWidth}
      height={iconHeight}
      viewBox="0 0 18 18"
      fill="none"
      {...props}
    >
      <g clip-path="url(#clip0_2142_41125)">
        <circle
          cx="9"
          cy="9"
          r="7.25"
          stroke={iconColor}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <circle cx="6" cy="7" r="1" fill={iconColor} />
        <circle cx="12" cy="7" r="1" fill={iconColor} />
        <path
          d="M5.31939 11.875C5.69241 11.2289 6.22892 10.6924 6.875 10.3194C7.52108 9.94638 8.25397 9.75 9 9.75C9.74603 9.75 10.4789 9.94638 11.125 10.3194C11.7711 10.6924 12.3076 11.2289 12.6806 11.875"
          stroke={iconColor}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_2142_41125">
          <rect width="18" height="18" fill="white" />
        </clipPath>
      </defs>
    </StyledSVG>
  );
};
